import React from 'react'
import {FormattedMessage,FormattedHTMLMessage} from 'react-intl'
import {Link} from 'react-router-dom'
import {PHOTO_RATIO} from '../../../config/constants'
import {getCarTypeUrl} from '../../../helpers/car'
import LocaleText from '../../common/LocaleText'
import ResponsiveImg, { getResponsiveSrcSetsFromWH } from '../../common/ResponsiveImg'
import {useLocale} from '../../hocs/hooks'
import styles from './CarItem.scss'
import { getGlobalEnv } from '../../../helpers/coreUtil'

const CarTypeItem = ({carType, carTypePage}: {
  carType: {_id:number, category:string, description:string, url:string, nameCategory?: string},
  carTypePage : boolean
}) => {
  const locale = useLocale()
  const caption = 'Car Photo'
  const cdn = getGlobalEnv('CDN_BASE_URL')
  const srcSet = getResponsiveSrcSetsFromWH(carType.url, 200, undefined, { webp: true, cdn })
  const style = carTypePage ? styles.containerCarTypePage : styles.containerCarType
  return <div className={[style,'flex-grow-0 flex-shrink-0 d-flex flex-column position-relative'].filter(Boolean).join(' ')}>
    <div className={[styles.image].filter(Boolean).join(' ')}>
      <Link to={getCarTypeUrl(locale, carType, false)}
            className={[styles.imgWrapper,carTypePage && styles.imgWrapperCarType, 'd-flex align-items-center justify-content-center'].join(' ')}>
        <ResponsiveImg caption={caption}
                        url={carType.url}
                        noLazy={false}
                        srcSet={srcSet}
                        className={styles.photo}/>
      </Link>
    </div>
    <div className={['text-left d-flex flex-column', styles.info].join(' ')}>
      <div className={[styles.carListText].join(' ')}>
        <Link to={getCarTypeUrl(locale, carType, false)}
              className={
                ['d-block font-weight-bold text-dark text-carstay-black']
                  .filter(Boolean).join(' ')
              }>
          <FormattedMessage id={carType.category}/>
        </Link>
        <FormattedHTMLMessage id={carType.description}/>
      </div>  
    </div>
  </div>
}
CarTypeItem.displayName = 'CarTypeItem'
export default CarTypeItem
